// extracted by mini-css-extract-plugin
export default {"wrap":"suggested-keywords-module--wrap--sDb3g"};